import { updateShowBulkEditDataAcquisitionTypeIcon } from "../../reducers/your-reducer";
import store from "../../reducers/store";

export const countCheckedNodesWithDataAcquisitionAttribute = (item) => {
  let count = 0;

  if (item.selected && item.attributes?.data_acquisition_type) {
    count += 1;
  }

  if (item.children) {
    item.children.forEach((child) => {
      count += countCheckedNodesWithDataAcquisitionAttribute(child);
    });
  }

  return count;
};

const getTransferedAndTransferedFilteredCheckedNodesWithDataAcquisitionAttribute =
  () => {
    const transferedData =
      store.getState().yourSlice.editStructurePageTransferData;
    const filteredTransferedData =
      store.getState().yourSlice.editStructurePageTransferDataFiltered;

    let countTransferredNodesWithDataAcquisitionAttributesAndChecked = 0;
    if (transferedData) {
      countTransferredNodesWithDataAcquisitionAttributesAndChecked =
        countCheckedNodesWithDataAcquisitionAttribute(
          transferedData.nodeset.root_node,
        );
    }

    let countTransferredNodesWithDataAcquisitionAttributesFilteredAndChecked = 0;
    if (filteredTransferedData) {
      countTransferredNodesWithDataAcquisitionAttributesFilteredAndChecked =
        countCheckedNodesWithDataAcquisitionAttribute(
          filteredTransferedData.nodeset.root_node,
        );
    }

    return {
      countTransferredNodesWithDataAcquisitionAttributesAndChecked,
      countTransferredNodesWithDataAcquisitionAttributesFilteredAndChecked,
    };
  };

export const updateDataAcquisitionBulkEditIconState = () => {
  const {
    countTransferredNodesWithDataAcquisitionAttributesAndChecked,
    countTransferredNodesWithDataAcquisitionAttributesFilteredAndChecked,
  } =
    getTransferedAndTransferedFilteredCheckedNodesWithDataAcquisitionAttribute();

  if (
    countTransferredNodesWithDataAcquisitionAttributesAndChecked > 1 ||
    countTransferredNodesWithDataAcquisitionAttributesFilteredAndChecked > 1
  ) {
    store.dispatch(updateShowBulkEditDataAcquisitionTypeIcon(true));
  } else {
    store.dispatch(updateShowBulkEditDataAcquisitionTypeIcon(false));
  }
};
